import axios from "axios";
import { buildApiUrl } from "../config/api";

export const PRIMARY_TERMS = ["Term 1", "Term 2", "Term 3"];
export const SECONDARY_TERMS = ["Term 1", "Term 2", "Term 3"];

export async function fetchPromotionReviews(schoolId, { classId, studentId, academicYear }) {
    const params = { academicYear };
    if (classId) params.classId = classId;
    if (studentId) params.studentId = studentId;
    const { data } = await axios.get(buildApiUrl(`/SchoolRollover/${schoolId}/promotion-reviews`), { params });
    return data;
}

export async function savePromotionReviews(schoolId, { academicYear, teacherId, reviews }) {
    const { data } = await axios.post(buildApiUrl(`/SchoolRollover/${schoolId}/promotion-reviews`), {
        academicYear,
        teacherId,
        reviews,
    });
    return data;
}

export async function autoApplyPromotionReviews(schoolId, { academicYear, classId, teacherId }) {
    const { data } = await axios.post(buildApiUrl(`/SchoolRollover/${schoolId}/auto-apply-reviews`), {
        academicYear,
        classId,
        teacherId,
    });
    return data;
}

function downloadTextFile(filename, text) {
    const blob = new Blob([text], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
}

export async function downloadPromotionReport(schoolId, { academicYear }) {
    const params = { academicYear, format: "csv" };
    try {
        const response = await axios.get(buildApiUrl(`/SchoolRollover/${schoolId}/promotion-report`), {
            params,
            responseType: "blob",
        });
        const disposition = response.headers["content-disposition"] || "";
        const match = /filename="([^"]+)"/i.exec(disposition);
        const filename = match?.[1] || `Promotion-Report-${academicYear || "year"}.csv`;
        const url = URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
    } catch (err) {
        const { data } = await axios.get(buildApiUrl(`/SchoolRollover/${schoolId}/promotion-report`), {
            params: { academicYear },
        });
        if (data?.csv) {
            downloadTextFile(data.filename || `Promotion-Report-${academicYear}.csv`, data.csv);
            return data;
        }
        throw err;
    }
}

export async function fetchPromotionReportMeta(schoolId, { academicYear }) {
    const { data } = await axios.get(buildApiUrl(`/SchoolRollover/${schoolId}/promotion-report`), {
        params: { academicYear },
    });
    return data;
}
